import React from "react"
import { connect } from "react-redux"
import Tooltip from "../../Tooltip"
import ShopOrderTooltipHeaderNav from "./ShopOrderTooltipHeaderNav"
import TransactionsTab from "./TransactionsTab"
import DetailsTab from "./DetailsTab"
import ServicesTab from "./ServicesTab"
import NotesTab from "./NotesTab"
import IssuesTab from "./IssuesTab"
import InvoiceTab from "./InvoiceTab"
import InvoiceAiMappingTab from "./InvoiceAiMappingTab"
import { GREEN } from "../../../constants/colors"
import {
  DETAILS_TAB, SERVICES_TAB, NOTES_TAB, ISSUES_TAB, INVOICE_TAB, TRANSACTIONS_TAB, LINE_ITEMS_TAB
} from "../../../constants/orders"

class ShopOrderTooltip extends React.Component {
  state = {
    activeTab: DETAILS_TAB
  }

  switchTab = (tab) => {
    this.setState({ activeTab: tab })
  }

  onSaveMapping = (event, data, invoiceItem) => {
    let invoiceMappingUpdates = {...this.state.invoiceMappingUpdates}
    invoiceMappingUpdates[invoiceItem] = data.value
    this.setState({invoiceMappingUpdates: invoiceMappingUpdates})
  }

  updateMappings = () => {
    let mappings = []
    let invoiceMappingUpdates = {...this.state.invoiceMappingUpdates}
    Object.keys(invoiceMappingUpdates).forEach((key) =>
      mappings.push({
        ai_desc: invoiceMappingUpdates[key],
        invoice_desc: key,
        company_id: this.props.order.shop.company_id
      })
    )
    this.props.dispatch({
      type: 'MAPPING_CREATE_OR_UPDATE_SAGA',
      payload: mappings
    })
  }

  updateOrder = (payload) => {
    this.props.dispatch({
      type: 'SHOP_ORDERS_UPDATE_SAGA',
      payload: { id: this.props.order.id, ...payload }
    })
  }

  handleRefund = (payload, successCallback) => {
    this.props.dispatch({
      type: 'SHOP_ORDERS_REFUND_SAGA',
      payload: payload,
      successCallback: successCallback
    })
  }

  handleResolution = () => {
    this.props.dispatch({
      type: 'SHOP_ORDERS_RESOLUTION_SAGA',
      payload: { id: this.props.order.id },
    })
  }

  render() {
    const { order, customer, vehicle, shop, orderServices, tabData } = this.props
    const { id, is_fixed_price, order_issue, internal_notes, local_appointment_datetime } = order
    const { activeTab } = this.state

    return (
      <Tooltip
        trigger={<span>{id}</span>}
        content={
          <div style={{ width: is_fixed_price ? "850px" : "750px", cursor: "auto" }}>
            <ShopOrderTooltipHeaderNav
              activeTab={activeTab}
              switchTab={this.switchTab}
              tabData={tabData}
              order={order}
            />

            {activeTab === DETAILS_TAB &&
              <DetailsTab
                customer={customer}
                vehicle={vehicle}
                shop={shop}
                localAppointmentDatetime={local_appointment_datetime}
              />
            }
            {activeTab === SERVICES_TAB &&
              <ServicesTab order={order} orderServices={orderServices} updateOrder={this.updateOrder} />
            }
            {activeTab === NOTES_TAB &&
              <NotesTab internalNotes={internal_notes} updateOrder={this.updateOrder} />
            }
            {activeTab === ISSUES_TAB &&
              <IssuesTab orderIssue={order_issue} updateOrder={this.updateOrder} />
            }
            {activeTab === INVOICE_TAB &&
              <InvoiceTab
                order={order}
                handleRefund={this.handleRefund}
                handleResolution={this.handleResolution}
              />
            }
            {activeTab === TRANSACTIONS_TAB &&
              <TransactionsTab order={order} handleRefund={this.handleRefund}/>
            }
            {activeTab === LINE_ITEMS_TAB &&
              <InvoiceAiMappingTab
                order={order}
                onSaveMapping={this.onSaveMapping}
                onSubmitMapping={this.updateMappings}
              />
            }
          </div>
        }
        infoIcon
        infoIconColor={is_fixed_price ? GREEN : 'black'}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}

export default connect(mapStateToProps)(ShopOrderTooltip)
